var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.25H1.49609C0.808594 0.25 0.25 0.816406 0.25 1.51172V16.4883C0.25 17.1836 0.808594 17.75 1.49609 17.75H16.5C17.1875 17.75 17.75 17.1836 17.75 16.4883V1.51172C17.75 0.816406 17.1875 0.25 16.5 0.25ZM5.53906 15.25H2.94531V6.89844H5.54297V15.25H5.53906ZM4.24219 5.75781C3.41016 5.75781 2.73828 5.08203 2.73828 4.25391C2.73828 3.42578 3.41016 2.75 4.24219 2.75C5.07031 2.75 5.74609 3.42578 5.74609 4.25391C5.74609 5.08594 5.07422 5.75781 4.24219 5.75781ZM15.2617 15.25H12.668V11.1875C12.668 10.2188 12.6484 8.97266 11.3203 8.97266C9.96875 8.97266 9.76172 10.0273 9.76172 11.1172V15.25H7.16797V6.89844H9.65625V8.03906H9.69141C10.0391 7.38281 10.8867 6.69141 12.1484 6.69141C14.7734 6.69141 15.2617 8.42188 15.2617 10.6719V15.25Z",
    fill: "#292830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.13f450e3064f38b7f627849926292467.svg";
export { ForwardRef as ReactComponent };